"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var cacheGetContentSearcher_1 = require("../eventApi/cacheGetContentSearcher");
/**
 * FirefoxTypeAfterLink Component helps handle typing event when cursor is right after a link.
 * When typing/pasting after a link, browser may put the new charactor inside link.
 * This plugin overrides this behavior to always insert outside of link.
 *
 * TODO: Rename this file in next major release since it is not only applied to Firefox now
 */
var FirefoxTypeAfterLink = /** @class */ (function () {
    function FirefoxTypeAfterLink() {
    }
    FirefoxTypeAfterLink.prototype.getName = function () {
        return 'FirefoxTypeAfterLink';
    };
    FirefoxTypeAfterLink.prototype.initialize = function (editor) {
        this.editor = editor;
    };
    FirefoxTypeAfterLink.prototype.dispose = function () {
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    FirefoxTypeAfterLink.prototype.onPluginEvent = function (event) {
        if ((roosterjs_editor_dom_1.Browser.isFirefox && event.eventType == 1 /* KeyPress */) ||
            event.eventType == 9 /* BeforePaste */) {
            var range = this.editor.getSelectionRange();
            if (range && range.collapsed && this.editor.getElementAtCursor('A[href]')) {
                var searcher = cacheGetContentSearcher_1.cacheGetContentSearcher(event, this.editor);
                var inlineElement = searcher.getInlineElementBefore();
                if (inlineElement instanceof roosterjs_editor_dom_1.LinkInlineElement) {
                    this.editor.select(new roosterjs_editor_dom_1.Position(inlineElement.getContainerNode(), -3 /* After */));
                }
            }
        }
    };
    return FirefoxTypeAfterLink;
}());
exports.default = FirefoxTypeAfterLink;
//# sourceMappingURL=FirefoxTypeAfterLink.js.map